import "./App.css";
import UserRoutes from "./Pages/User-panel/Route";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Register from "./Components/Authentication/Register";

function App() {
  return (
    <>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Routes>
          <Route path="/*" element={<UserRoutes />}></Route>
          <Route path="/signup" element={<Register />}></Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
